(function () {
  if (window.MoonsylCurrency && window.MoonsylCurrency.version) return;

  var version = "2026-07-15.1";
  var MARKET = window.__MOONSYL_SHOPIFY_MARKET__ || window.__MOONSYL_SHOPIFY_CURRENCY__ || {};
  var FX_ENDPOINT = String(window.__MOONSYL_FX_API_URL__ || "https://crystal-shopify-embed-app.onrender.com/api/public/fx-rates").trim();
  var COUNTRY_TO_CURRENCY = { US: "USD", GB: "GBP", FR: "EUR", DE: "EUR", RU: "RUB", BR: "BRL", JP: "JPY", KR: "KRW", AE: "AED", SA: "AED" };
  var LOCALE_TO_COUNTRY = { en: "US", fr: "FR", de: "DE", ru: "RU", pt: "BR", ja: "JP", ko: "KR", ar: "AE" };
  var SYMBOLS = { USD: "$", GBP: "\u00a3", EUR: "\u20ac", RUB: "\u20bd", BRL: "R$", JPY: "\u00a5", KRW: "\u20a9", AED: "AED" };
  var SUPPORTED = ["USD", "GBP", "EUR", "RUB", "BRL", "JPY", "KRW", "AED"];
  var ZERO_DECIMAL = { JPY: true, KRW: true };
  var SOURCE_CURRENCY_RE = /(US\$|USD|BRL|R\$|\$|GBP|\u00a3|EUR|\u20ac|RUB|\u20bd|JPY|\u00a5|KRW|\u20a9|AED)\s*([0-9][0-9,]*(?:\.[0-9]{1,2})?)\s*(USD|GBP|EUR|RUB|BRL|JPY|KRW|AED)?|([0-9][0-9,]*(?:\.[0-9]{1,2})?)\s*(USD|GBP|EUR|RUB|BRL|JPY|KRW|AED)/g;
  var rates = { USD: 1, GBP: 0.79, EUR: 0.92, RUB: 90, BRL: 5.45, JPY: 156, KRW: 1370, AED: 3.6725 };
  var FX_CACHE_KEY = "moonsyl_fx_rates_usd_v6";
  var FX_CACHE_TTL = 6 * 60 * 60 * 1000;
  var readyCallbacks = [];
  var observerTimer = 0;
  var currentTarget = resolveTargetCurrency();

  function normalizeLocale(value) {
    return String(value || "").trim().toLowerCase().replace("_", "-").split("-")[0];
  }

  function stored(key) {
    try { return String(window.localStorage && window.localStorage.getItem(key) || "").trim(); }
    catch (error) { return ""; }
  }

  function storedAny(keys) {
    for (var i = 0; i < keys.length; i += 1) {
      var value = stored(keys[i]);
      if (value) return value;
    }
    return "";
  }

  function pathLocale() {
    return normalizeLocale(String(window.location.pathname || "").split("/").filter(Boolean)[0] || "");
  }

  function countryFromLocale(locale) {
    return LOCALE_TO_COUNTRY[normalizeLocale(locale)] || "";
  }

  function selectedCountry() {
    var storedCountry = storedAny(["moonsyl_country_selected", "moonsyl_country_preference"]).toUpperCase();
    if (/^[A-Z]{2}$/.test(storedCountry)) return storedCountry;

    var localeCountry = countryFromLocale(pathLocale())
      || countryFromLocale(window.MoonsylI18n && window.MoonsylI18n.locale)
      || countryFromLocale(window.__MOONSYL_LOCALE__)
      || countryFromLocale(storedAny(["moonsyl_language_selected", "moonsyl_language_preference"]));
    if (localeCountry) return localeCountry;

    var marketCountry = String(MARKET.countryCode || MARKET.country_code || MARKET.country || "").trim().toUpperCase();
    if (/^[A-Z]{2}$/.test(marketCountry)) return marketCountry;
    return "US";
  }

  function resolveTargetCurrency() {
    var storedCurrency = storedAny(["moonsyl_currency_selected", "moonsyl_currency_preference"]).toUpperCase();
    if (SUPPORTED.indexOf(storedCurrency) >= 0) return storedCurrency;
    return COUNTRY_TO_CURRENCY[selectedCountry()] || "USD";
  }

  function sourceCurrencyFromMatch(primary, suffix) {
    var raw = String(suffix || primary || "").toUpperCase();
    if (raw === "$" || raw === "US$") return "USD";
    if (raw === "R$" || raw === "BRL") return "BRL";
    if (raw === "\u00a3") return "GBP";
    if (raw === "\u20ac") return "EUR";
    if (raw === "\u20bd") return "RUB";
    if (raw === "\u00a5") return "JPY";
    if (raw === "\u20a9") return "KRW";
    if (SUPPORTED.indexOf(raw) >= 0) return raw;
    return "USD";
  }

  function parseAmount(value) {
    var n = Number(String(value || "").replace(/,/g, ""));
    return Number.isFinite(n) ? n : NaN;
  }

  function readCachedRates() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(FX_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.rates || Date.now() - Number(parsed.ts || 0) > FX_CACHE_TTL) return null;
      return parsed.rates;
    } catch (error) {
      return null;
    }
  }

  function writeCachedRates(nextRates) {
    try {
      if (window.localStorage) window.localStorage.setItem(FX_CACHE_KEY, JSON.stringify({ ts: Date.now(), rates: nextRates }));
    } catch (error) {}
  }

  function hydrateCachedRates() {
    var cached = readCachedRates();
    if (!cached) return;
    Object.keys(cached).forEach(function (code) {
      var value = Number(cached[code]);
      if (Number.isFinite(value) && value > 0) rates[code] = value;
    });
  }

  function convertAmount(amount, from, to) {
    var source = String(from || "USD").toUpperCase();
    var target = String(to || currentTarget || "USD").toUpperCase();
    var n = Number(amount || 0);
    if (!Number.isFinite(n)) return NaN;
    if (source === target) return n;
    var sourceRate = Number(rates[source] || (source === "USD" ? 1 : 0));
    var targetRate = Number(rates[target] || (target === "USD" ? 1 : 0));
    if (!sourceRate || !targetRate) return NaN;
    return (n / sourceRate) * targetRate;
  }

  function formatAmount(amount, code) {
    var currency = String(code || currentTarget || "USD").toUpperCase();
    var decimals = ZERO_DECIMAL[currency] ? 0 : 2;
    var value = Number(amount || 0);
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    } catch (error) {
      return (SYMBOLS[currency] || currency + " ") + value.toFixed(decimals);
    }
  }

  function formatCents(cents, sourceCurrency, requestedTarget) {
    currentTarget = resolveTargetCurrency();
    var from = String(sourceCurrency || "USD").toUpperCase();
    var to = String(requestedTarget || currentTarget || "USD").toUpperCase();
    var baseAmount = Number(cents || 0) / 100;
    var converted = convertAmount(baseAmount, from, to);
    return Number.isFinite(converted) ? formatAmount(converted, to) : formatAmount(baseAmount, from);
  }

  function convertText(text) {
    currentTarget = resolveTargetCurrency();
    var target = currentTarget;
    if (!target || target === "USD") return text;
    SOURCE_CURRENCY_RE.lastIndex = 0;
    return String(text || "").replace(SOURCE_CURRENCY_RE, function (match, prefix, amount1, suffix1, amount2, suffix2) {
      var amount = parseAmount(amount1 || amount2);
      if (!Number.isFinite(amount)) return match;
      var source = sourceCurrencyFromMatch(prefix, suffix1 || suffix2);
      if (source === target) return match;
      var converted = convertAmount(amount, source, target);
      if (!Number.isFinite(converted)) return match;
      return formatAmount(converted, target);
    });
  }

  function shouldSkipNode(node) {
    if (!node) return true;
    if (node.nodeType === 3) return shouldSkipNode(node.parentElement);
    if (node.nodeType !== 1) return true;
    var tag = String(node.tagName || "").toLowerCase();
    if (tag === "script" || tag === "style" || tag === "noscript" || tag === "template") return true;
    if (node.closest && node.closest("[data-moonsyl-no-currency], [data-moonsyl-no-translate]")) return true;
    return false;
  }

  function convertTextNode(node) {
    if (!node || !node.nodeValue || shouldSkipNode(node)) return;
    var original = node.__moonsylCurrencyOriginal || node.nodeValue;
    SOURCE_CURRENCY_RE.lastIndex = 0;
    if (!node.__moonsylCurrencyOriginal && SOURCE_CURRENCY_RE.test(node.nodeValue)) {
      node.__moonsylCurrencyOriginal = original;
    }
    SOURCE_CURRENCY_RE.lastIndex = 0;
    if (!node.__moonsylCurrencyOriginal) return;
    var next = convertText(original);
    if (next && next !== node.nodeValue) node.nodeValue = next;
  }

  function convertDom(root) {
    currentTarget = resolveTargetCurrency();
    var scope = root || document.body || document.documentElement;
    if (!scope || shouldSkipNode(scope)) return;
    if (scope.nodeType === 3) {
      convertTextNode(scope);
      return;
    }
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var node = walker.currentNode;
    while (node) {
      convertTextNode(node);
      node = walker.nextNode();
    }
  }

  function loadRates() {
    var symbols = SUPPORTED.join(",");
    return fetch(FX_ENDPOINT + "?base=USD&symbols=" + encodeURIComponent(symbols), {
      mode: "cors",
      credentials: "omit",
      headers: { Accept: "application/json" }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        var nextRates = payload && payload.rates;
        if (nextRates && typeof nextRates === "object") {
          SUPPORTED.forEach(function (code) {
            var value = Number(nextRates[code]);
            if (Number.isFinite(value) && value > 0) rates[code] = value;
          });
          writeCachedRates(rates);
        }
      })
      .catch(function () {})
      .then(function () {
        readyCallbacks.splice(0).forEach(function (fn) {
          try { fn(); } catch (error) {}
        });
        convertDom(document.body);
      });
  }

  function watch() {
    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      var root = null;
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          root = mutations[i].target;
          break;
        }
        if (mutations[i].type === "characterData") {
          root = mutations[i].target && mutations[i].target.parentElement;
          break;
        }
      }
      if (!root) return;
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(function () { convertDom(root); }, 40);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function ready(fn) {
    if (typeof fn !== "function") return;
    readyCallbacks.push(fn);
  }

  hydrateCachedRates();

  window.MoonsylCurrency = {
    version: version,
    get currencyCode() { return resolveTargetCurrency(); },
    get countryCode() { return selectedCountry(); },
    rates: function () { return Object.assign({}, rates); },
    formatCents: formatCents,
    formatAmount: formatAmount,
    convertAmount: convertAmount,
    convertText: convertText,
    convertDom: convertDom,
    refresh: function () {
      currentTarget = resolveTargetCurrency();
      convertDom(document.body);
      return loadRates();
    },
    ready: ready
  };

  function boot() {
    currentTarget = resolveTargetCurrency();
    convertDom(document.body);
    loadRates();
    watch();
    [80, 220, 520, 1000, 2200, 4200].forEach(function (delay) {
      window.setTimeout(function () { convertDom(document.body); }, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
